var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpCenterBlack24Dp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "icons/Action/assignment_ind_black_24dp")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tablet-View/Navigation/Side-nav_Tracker",
    transform: "translate(-21.000000, -847.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15-Copy-2",
    transform: "translate(0.000000, 826.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(17.333333, 17.333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 29.3333335,
    height: 29.3333335
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1944445,20.4600001 C16.1944445,21.3033334 15.5466667,22.0000001 14.6666667,22.0000001 C13.8111112,22.0000001 13.1266667,21.3155557 13.1266667,20.4600001 C13.1266667,19.5922223 13.8111112,18.9322223 14.6666667,18.9322223 C15.5344445,18.9322223 16.1944445,19.6044445 16.1944445,20.4600001 Z M14.6544445,7.33333337 C12.4911112,7.33333337 11.0122223,8.73888893 10.4622223,10.3766667 L12.4666667,11.2200001 C12.7355556,10.4011112 13.3711112,9.41111115 14.6666667,9.41111115 C16.6466667,9.41111115 17.0377779,11.2688889 16.3411112,12.2588889 C15.6811112,13.2000001 14.5444445,13.8355556 13.9455556,14.898889 C13.468889,15.7422223 13.5666667,16.7200001 13.5666667,17.318889 L15.7911112,17.318889 C15.7911112,16.1822223 15.8766667,15.9500001 16.0600001,15.5955556 C16.5366667,14.7155556 17.4166667,14.3000001 18.3455556,12.9433334 C19.1766668,11.7211112 18.858889,10.0588889 18.3211112,9.17888893 C17.6977779,8.15222226 16.4633334,7.33333337 14.6544445,7.33333337 Z M23.2222223,6.11111114 L6.11111114,6.11111114 L6.11111114,23.2222223 L23.2222223,23.2222223 L23.2222223,6.11111114 M23.2222223,3.66666668 C24.5666668,3.66666668 25.6666667,4.76666669 25.6666667,6.11111114 L25.6666667,23.2222223 C25.6666667,24.5666668 24.5666668,25.6666667 23.2222223,25.6666667 L6.11111114,25.6666667 C4.76666669,25.6666667 3.66666668,24.5666668 3.66666668,23.2222223 L3.66666668,6.11111114 C3.66666668,4.76666669 4.76666669,3.66666668 6.11111114,3.66666668 L23.2222223,3.66666668 L23.2222223,3.66666668 Z",
    id: "Shape",
    fill: "#232323",
    fillRule: "nonzero"
  })))))));
}
export default SvgHelpCenterBlack24Dp;